export class ReadNotificationsAction {
  static readonly type = '[Notifications] Read';
  constructor(public ids: string | string[]) {}
}
